module.exports = __webpack_public_path__ + "static/media/skeptisk.c0e548c1.mp3";